export default "__VITE_ASSET__DkPaV8aU__"